"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.isClonedItem = exports.isTargetItem = exports.isActiveItem = exports.getRenderStageItemClasses = void 0;

var types_1 = require("../types"),
    common_1 = require("./common"),
    math_1 = require("./math");

exports.getRenderStageItemClasses = function (e, t) {
  void 0 === e && (e = 0);
  var i = t.fadeoutAnimationIndex,
      s = exports.isActiveItem(e, t) ? types_1.Modifiers.ACTIVE : "",
      r = exports.isClonedItem(e, t) ? types_1.Modifiers.CLONED : "",
      t = exports.isTargetItem(e, t) ? types_1.Modifiers.TARGET : "",
      e = e === i ? types_1.Classnames.ANIMATED : "";
  return common_1.concatClassnames(types_1.Classnames.STAGE_ITEM, s, r, t, e);
}, exports.isActiveItem = function (e, t) {
  void 0 === e && (e = 0);
  var i = t.activeIndex,
      s = t.itemsInSlide,
      r = t.itemsOffset,
      n = t.infinite,
      t = t.autoWidth,
      o = math_1.getShiftIndex(s, r);
  if (t && n) return e - o === i + r;
  t = i + o;
  return n ? t <= e && e < t + s : i <= e && e < t;
}, exports.isTargetItem = function (e, t) {
  void 0 === e && (e = 0);
  var i = t.activeIndex,
      s = t.itemsInSlide,
      r = t.itemsOffset,
      n = t.infinite,
      t = t.autoWidth,
      s = math_1.getShiftIndex(s, r);
  return n ? t && n ? e - s === i + r : e === i + s : e === i;
}, exports.isClonedItem = function (e, t) {
  void 0 === e && (e = 0);
  var i = t.itemsInSlide,
      s = t.itemsOffset,
      r = t.itemsCount,
      n = t.infinite,
      t = t.autoWidth;
  if (!n) return !1;
  if (t && n) return e < i || r - 1 + i < e;
  t = math_1.getShiftIndex(i, s);
  return e < t || r - 1 + t < e;
};